import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import multiCategory from './modules/multiCategory'
import classificationType from './modules/classificationType'
import payment from "./modules/payment"
import userMenu from "./modules/userMenu"
import article from "./modules/article"
import resource from "./modules/resource"
import dictionary from "./modules/dictionary"
import oneQuestionPerday from "./modules/oneQuestionPerday"
import learningCourse from "./modules/learningCourse"
import chapterType from "./modules/chapterType"
import testQuestion from "./modules/testQuestion"
import testPaper from "./modules/testPaper"
import friendLink from "./modules/friendlyLink"
import siteMessage from "./modules/siteMessage"
import discuss from "./modules/discuss"
import questionnaire from "./modules/questionnaire"
import questionOfAsk from "./modules/questionOfAsk"
import leaveMessage from "./modules/leaveMessage"
import consumption from "./modules/consumption"
import questionOfPapers from "./modules/questionOfPapers"
import advertising from "./modules/advertising"


const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        multiCategory,
        classificationType,
        payment,
        userMenu,
        article,
        resource,
        dictionary,
        oneQuestionPerday,
        learningCourse,
        chapterType,
        testQuestion,
        testPaper,
        friendLink,
        siteMessage,
        discuss,
        questionnaire,
        questionOfAsk,
        leaveMessage,
        consumption,
        questionOfPapers,
        advertising
    }
});

export default store;